// extracted by mini-css-extract-plugin
module.exports = {"overAll":"OverviewSummaryEdit_overAll__3Vr7m","svgEdit":"OverviewSummaryEdit_svgEdit__HFjOX","commentTextStyle":"OverviewSummaryEdit_commentTextStyle__21thR"};